export default __webpack_public_path__ + "img/whatsApp.96c0ad2c.svg";